import React from 'react';
import axios from 'axios';
import { Grid } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { PropTypes } from 'prop-types';
import { validationSchemaForServiceToMyAccountExistingConcierge } from '../balance-cancellation/FormModel/validationSchema';
import { formInitialValuesForExistingConcierge } from '../balance-cancellation/FormModel/formInitialValues';
import { CommonStyles } from '../balance-cancellation/CommonStyles';
import { base64Authorization } from '../utils/CommonFunctions';
import ExistingConciergeCustomerForm from './ExistingConciergeCustomerForm';
import { generateuuid } from '../../../app/CommonFunction';
import { API_CONFIG } from '../../../config/apiconfig';

const useCommonStyles = CommonStyles();

const ExistingConciergeCustomerContainer = (props) => {
  const CommonCssStyles = useCommonStyles();
  const {
    englishBot,
    sessionID,
    setExistingConciergeCustomer,
    formInProcessTrigger,
    handeButtonLinkMessage,
    setCustomerDetails,
    spinnerHandler,
    setShowRegisterCustomerButton,
    liveAgentJoined,
    sendToConnect,
    token,
    getAccessToken,
  } = props;

  const handleFormSubmit = (values, actions) => {
    setExistingConciergeCustomer(false);
    formInProcessTrigger(false);
    setShowRegisterCustomerButton(false);
    if (liveAgentJoined) {
      let cusDetails = `customerEmail: ${values.personEmail}\n customerDob: ${values.dob_date}\n customerSSN: ${values.socialSecurityNumber}`;
      sendToConnect(cusDetails);
    } else {
      const params = {
        sessionId: sessionID,
        customerEmail: values.personEmail,
        lineOfBusiness: values.accountType,
        dob: values.dob_date,
        ssn: values.socialSecurityNumber,
        conciergeCustomer: 'Y',
      };
      const uuid = generateuuid();
      axios
        .post(`${API_CONFIG.USER_FORM_URL}`, params, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_X_API_KEY,
            appid: 'comms',
            sessionId: sessionID,
            source: 'Chatbot',
            lang: englishBot ? 'ENG' : 'ESP',
            uuid,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.messages && data.messages[0].content.includes('templateType')) {
            const listPickerData = JSON.parse(data.messages[0].content);
            setCustomerDetails(listPickerData.data.content.sessionAttributes);
            setTimeout(() => {
              spinnerHandler(false);
              handeButtonLinkMessage(
                { text: listPickerData.data.content.title, value: '', isButtonMessage: false },
                false
              );
            }, 1000);
          }
        })
        .catch((err) => {
          spinnerHandler(false);
          if (
            err.message === 'Request failed with status code 403' ||
            err.message === 'Request failed with status code 401'
          ) {
            getAccessToken(true, 'liveAgent', params);
          }
        });
    }
  };
  return (
    <Formik
      initialValues={formInitialValuesForExistingConcierge}
      validationSchema={validationSchemaForServiceToMyAccountExistingConcierge}
      onSubmit={handleFormSubmit}
      data-testid="submit_testid"
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Grid item xs={12} className={CommonCssStyles.steps_grid} style={{ margin: '10px' }}>
            <ExistingConciergeCustomerForm
              englishBot={englishBot}
              setExistingConciergeCustomer={setExistingConciergeCustomer}
              spinnerHandler={spinnerHandler}
              liveAgentJoined={liveAgentJoined}
            />
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
ExistingConciergeCustomerContainer.propTypes = {
  englishBot: PropTypes.bool,
  sessionID: PropTypes.string,
  setExistingConciergeCustomer: PropTypes.func,
  formInProcessTrigger: PropTypes.func,
  handeButtonLinkMessage: PropTypes.func,
  setCustomerDetails: PropTypes.object,
  spinnerHandler: PropTypes.func,
  setShowRegisterCustomerButton: PropTypes.func,
  liveAgentJoined: PropTypes.bool,
  sendToConnect: PropTypes.func,
};
export default ExistingConciergeCustomerContainer;
